import EntityType from '@enums/EntityType';

export default function isEntitySkillLevel(entityType) {
  if (
    entityType === EntityType.ROLE_SKILL_LEVEL ||
    entityType === EntityType.PERSON_SKILL_LEVEL
  ) {
    return true;
  }
}
